/**
 * Which implementation currently answers /patients, /worklist,
 * /patients-v2, and /worklist-v2. "default" is today's arrangement
 * (/patients, /worklist proxied to qtrack-lc). "inverted" swaps it.
 */

/**
 * Input cookie: a per-user route-variant override. Nothing in this app
 * writes it — it is the slot a future per-user profile integration sets.
 * Read here and, client-side, via document.cookie (see utils/zoneRoutes.ts).
 */
export var ROUTE_VARIANT_OVERRIDE_COOKIE = "qure_route_variant_override";

/**
 * Output cookie: the resolved variant, written by middleware.ts on every
 * matched response so qtrack-lc (shared domain) can read it. Never read
 * back as an input — doing so used to pin browsers to a stale variant.
 */
export var ROUTE_VARIANT_COOKIE = "qure_route_variant";
function isRouteVariant(value) {
  return value === "default" || value === "inverted";
}

/**
 * Resolves which route variant applies to this request. A valid
 * NEXT_PUBLIC_ROUTE_VARIANT env var takes priority; the override cookie
 * (the slot a future per-user profile value lands in) applies only when
 * the env var is unset or unrecognized; otherwise "default". Never throws.
 */
export function resolveRouteVariant(request) {
  var _request$cookies$get;
  var envValue = process.env.NEXT_PUBLIC_ROUTE_VARIANT;
  if (isRouteVariant(envValue)) {
    return envValue;
  }
  var cookieValue = (_request$cookies$get = request.cookies.get(ROUTE_VARIANT_OVERRIDE_COOKIE)) === null || _request$cookies$get === void 0 ? void 0 : _request$cookies$get.value;
  return isRouteVariant(cookieValue) ? cookieValue : "default";
}